import React from 'react'
import { connect } from 'react-redux'
import ExpansionPanel from './ExpansionPanel'
import General from './General'
import Tasks from './Tasks'
import EventGoals from './EventGoals'
import language from 'utils/vast-languagepack'

export default connect(
	(state) => ({
		stepper: state.view.stepper.campaign,
		status: state.campaign.addOrEdit.campaign?.status,
	}),
	null,
)(({ stepper, status }) => {
	const arr =
		stepper === 1 && status !== 'L' && status !== 'C'
			? [
					{
						title: language.campaign.add.campaignGeneralHeading,
						Component: General,
						toolTip: language.campaign.add.toolTips.general,
					},
					{
						title: language.campaign.add.campaignEventGoalsHeading,
						Component: EventGoals,
						toolTip: language.campaign.add.toolTips.eventGoals,
					},
					{
						title: language.campaign.add.campaignTasksHeading,
						Component: Tasks,
						toolTip: language.campaign.add.toolTips.scheduleTasksCalendar,
					},
			  ]
			: stepper === 2 && status !== 'L' && status !== 'C'
			? [
					{
						title: language.campaign.add.campaignGeneralHeading,
						Component: General,
						toolTip: language.campaign.add.toolTips.general,
					},
					{
						title: language.campaign.add.campaignTasksHeading,
						Component: Tasks,
						toolTip: language.campaign.add.toolTips.scheduleTasksFunnel,
					},
			  ]
			: [
					{
						title: language.campaign.add.campaignGeneralHeading,
						Component: General,
						toolTip: language.campaign.add.toolTips.general,
					},
			  ]

	return (
		<div style={{ paddingRight: 7 }}>
			{arr.map((obj, idx) => {
				const { title, Component, toolTip } = obj
				return (
					<ExpansionPanel
						key={`expansionPanel${title}`}
						title={title}
						idx={idx}
						toolTip={toolTip}
					>
						<Component />
					</ExpansionPanel>
				)
			})}
		</div>
	)
})
